import React, {forwardRef, type ComponentPropsWithoutRef} from 'react';
import {motion} from 'framer-motion';

import {Icon} from '@spothero/ui';

const FramerMotionIcon = motion(Icon);

interface IconProps extends ComponentPropsWithoutRef<'svg'> {
    [k: string]: unknown;
}

const MotionIcon = forwardRef<SVGElement, IconProps>((props, ref) => {
    return <FramerMotionIcon {...props} ref={ref} />;
});

export default MotionIcon;
